import { type ReactNode } from "react";
import {
  AuthenticatedAppWrapper as SharedAuthenticatedAppWrapper,
  type TokenExchangeState,
} from "@legal-500/auth-client";
import LoadingState from "../LoadingState";
import EmptyState from "../EmptyState";
import { removeBootLoader } from "../../utils/bootLoader";
import { publicRuntimeConfig } from "../../config/publicRuntimeConfig";

const apiBaseUrl = publicRuntimeConfig.apiBaseUrl;

function buildExchangeBody(fronteggJwt: string): Record<string, unknown> {
  return { token: fronteggJwt };
}

function handleStateChange(state: TokenExchangeState): void {
  removeBootLoader();
}

function renderLoading(): ReactNode {
  return <LoadingState fullscreen message="Loading staff application..." />;
}

function renderError(error: Error, retry: () => void): ReactNode {
  return (
    <EmptyState
      variant="error"
      title="Authentication failed"
      message={`Failed to exchange authentication token: ${error.message}`}
      action={{ label: "Retry", onClick: retry }}
    />
  );
}

export default function AuthenticatedAppWrapper({ children }: { children: ReactNode }) {
  return (
    <SharedAuthenticatedAppWrapper
      tokenExchangeUrl={`${apiBaseUrl}/token`}
      buildExchangeBody={buildExchangeBody}
      onStateChange={handleStateChange}
      renderLoading={renderLoading}
      renderError={renderError}
    >
      {children}
    </SharedAuthenticatedAppWrapper>
  );
}
